(function(angular, module) {var editChangeController, state, stateConfig;

editChangeController = function(ChangeLogService, changeLogItem, authors) {
  'ngInject';
  this.authors = authors;
  this.data = changeLogItem;
  this.scopeOptions = ChangeLogService.scopeOptions;
  this.save = function(data) {
    return ChangeLogService.patch(changeLogItem, data);
  };
};

state = {
  url: '/edit',
  templateUrl: 'changeLog/new',
  controller: editChangeController,
  controllerAs: 'ctrl',
  resolve: {
    authors: function(ChangeLogService) {
      'ngInject';
      return ChangeLogService.getAuthors();
    }
  }
};

stateConfig = function($stateProvider) {
  'ngInject';
  return $stateProvider.state('changeLog.item.edit', state);
};

module.config(stateConfig);
})(angular, angular.module("changeLog"));